import { CHARTING_TABLE_OBJECT } from "../../config/constants/Constants";

const SITE_KEYS = ["db", "b", "mb", "dp", "p", "mp", "dl", "l", "ml"];

/**
 * Merge persisted teeth_data onto the current chart template so new site fields
 * (for example calculus and erythema) are present without overwriting values.
 */
export const normalizeTeethData = (teethData) => {
    const normalized = JSON.parse(JSON.stringify(CHARTING_TABLE_OBJECT));

    if (!teethData) {
        return normalized;
    }

    Object.keys(normalized).forEach((toothNum) => {
        const sourceTooth = teethData[toothNum];
        if (!sourceTooth) {
            return;
        }

        normalized[toothNum] = {
            ...normalized[toothNum],
            missing: sourceTooth.missing ?? normalized[toothNum].missing,
            implant: sourceTooth.implant ?? normalized[toothNum].implant,
            mobility: sourceTooth.mobility ?? normalized[toothNum].mobility
        };

        SITE_KEYS.forEach((siteKey) => {
            if (sourceTooth[siteKey]) {
                normalized[toothNum][siteKey] = {
                    ...normalized[toothNum][siteKey],
                    ...sourceTooth[siteKey]
                };
            }
        });
    });

    return normalized;
};

export const DEFAULT_SUMMARY_DATA = {
    recording: {
        calculus: "not_recorded",
        erythema: "not_recorded"
    }
};

export const normalizeSummaryData = (summaryData) => {
    const normalized = JSON.parse(JSON.stringify(DEFAULT_SUMMARY_DATA));

    if (!summaryData?.recording) {
        return normalized;
    }

    if (summaryData.recording.calculus) {
        normalized.recording.calculus = summaryData.recording.calculus;
    }

    if (summaryData.recording.erythema) {
        normalized.recording.erythema = summaryData.recording.erythema;
    }

    return normalized;
};
